import React, {useState} from 'react';

import styles from './LoginOrSignIn.module.css'
import {Input} from "../../../../ui/DataEntry/Input/Input.tsx";
import {Button} from "../../../../ui/General/Button/Button.tsx";
import {formatPhone, getNormalizedPhone} from "../../../../utils/formatters/index.ts";
import {Loader} from "../../../../ui/Loader/Loader.tsx";
import { API_URL } from '../../../../config.tsx';

interface Props {
    onAuth: (isAuth: boolean | null) => void
    onPhoneChange: (phone: string) => void,
    phoneNumber: string,
    setIsSendPassword: (isSendPassword: boolean) => void,
    onLoggedOrSignedIn: (signIn: boolean) => void,
}

export const RestorePassword: React.FC<Props> = ({onAuth, onPhoneChange, phoneNumber, setIsSendPassword, onLoggedOrSignedIn, }) => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [failedPhone, setFailedPhone] = useState<boolean>(false);

    const handleChangePhoneNumber = (phoneNumber: string) => {
        setFailedPhone(false);
        onPhoneChange(phoneNumber);
    }

    const sendPassword = () => {
        if (getNormalizedPhone(phoneNumber).length !== 10) {
            setFailedPhone(true);
            return;
        }
        setIsLoading(true);
        fetch(`${API_URL}/send_password`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify({phoneNumber}),
        }).then(() => {
            setIsLoading(false);
            onAuth(null);
            onLoggedOrSignedIn(false);
            setIsSendPassword(true);
        })
    }
    return (
        <div className={styles.wrapper}>
            <div className={styles.hedaer}>
                <h4 className={styles.title}>Восстановление пароля</h4>
            </div>
            <div className={styles.body}>
                {failedPhone && (
                    <div className={styles.invalidInputText}>
                        <div>Некорректно указан телефон.</div>
                        <div>Пожалуйста, проверьте введенные данные.</div>
                    </div>
                )}
                <Input
                    hasBorder
                    placeholder='Номер телефона'
                    value={formatPhone(phoneNumber)}
                    changeStateValue={handleChangePhoneNumber}
                />
                <Button className={styles.btn} onClick={() => {sendPassword();}}>
                    {isLoading ? <><Loader /> Отправляем пароль</> : <>Получить пароль</>}
                </Button>
            </div>
        </div>
    );
};
